import { Outlet } from 'react-router';
import { ToastStateHandler } from '../api';
import { useContainer, useLanguageData, useWaitForNotification } from '../hooks';
import { BranchHandler, PolicyHandler } from './organization';
import { UserHandler } from './user';
import { GlobalApi } from '../util/Global';

const GlobalWebSocketHandler = () => {
    const languageData = useLanguageData();
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const globalApi: GlobalApi = useContainer(GlobalApi);

    const ph = new PolicyHandler(toastHandler, languageData);
    useWaitForNotification('POLICY_CREATION_SUCCEEDED', ph.policyCreationSucceeded.bind(ph));
    useWaitForNotification('POLICY_CREATION_FAILED', ph.policyCreationFailed.bind(ph));
    useWaitForNotification('POLICY_MEMBERS_CHANGE_FAILED', ph.policyMembersChangeFailed.bind(ph));
    useWaitForNotification('POLICY_NAME_UPDATED', ph.policyNameUpdated.bind(ph));

    const uh = new UserHandler(toastHandler, languageData, globalApi);
    useWaitForNotification('USER_ROLE_CHANGED', uh.userRoleChanged.bind(uh));
    useWaitForNotification('TRANSFER_OWNERSHIP_SUCCEEDED', uh.userRoleChanged.bind(uh));
    useWaitForNotification('NOTIFICATION_CREATION_INITIATED', uh.notificationCreation.bind(uh));

    const bh = new BranchHandler(toastHandler, languageData);
    useWaitForNotification('BRANCH_DELETION_FAILED', bh.branchCreationFailed.bind(bh));

    return <Outlet />;
};

export default GlobalWebSocketHandler;
